import { render, staticRenderFns } from "./jurisdiction.vue?vue&type=template&id=54fb24a3&scoped=true&"
import script from "./jurisdiction.vue?vue&type=script&lang=js&"
export * from "./jurisdiction.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/css/common/nav.less?vue&type=style&index=0&id=54fb24a3&scoped=true&lang=less&"
import style1 from "../../../assets/css/common/table.less?vue&type=style&index=1&id=54fb24a3&scoped=true&lang=less&"
import style2 from "./jurisdiction.vue?vue&type=style&index=2&id=54fb24a3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fb24a3",
  null
  
)

export default component.exports